import { getAddressComponent } from "pages/dashboard/documents/time-and-attendance/utils/shiftTablesUtils"

interface AddressComponent {
  long_name: string
  short_name: string
  types: string[]
}

export interface ParsedGoogleAddress {
  /** Street line — number + route, falling back to the first segment of the formatted address. */
  addressLine1: string
  city: string
  zip: string
  /** ISO alpha-2 country code (e.g. "NG"). */
  countryCode: string
  /** Full state/province name (e.g. "Lagos"). */
  stateName: string
  /** Abbreviated state/province code from Google (e.g. "LA"). */
  stateShortName: string
}

/**
 * Turn a Google geocoder result (as handed back by GeoPicker's `onPlaceDetails`)
 * into the flat fields the workplace forms store. Mirrors the address_components
 * parsing already used in the time-and-attendance workplace flow.
 */
export function parseGooglePlace(place: any): ParsedGoogleAddress {
  const comps = (place?.address_components ?? []) as AddressComponent[]

  const streetNumber = getAddressComponent(comps, "street_number")?.long_name ?? ""
  const route = getAddressComponent(comps, "route")?.long_name ?? ""
  const addressLine1 =
    `${streetNumber} ${route}`.trim() ||
    (place?.formatted_address ?? "").split(",")[0].trim()

  const city =
    getAddressComponent(comps, "locality")?.long_name ??
    getAddressComponent(comps, "postal_town")?.long_name ??
    getAddressComponent(comps, "administrative_area_level_2")?.long_name ??
    ""

  const zip = getAddressComponent(comps, "postal_code")?.long_name ?? ""
  const countryCode = getAddressComponent(comps, "country")?.short_name ?? ""

  const stateComp = getAddressComponent(comps, "administrative_area_level_1")
  const stateName = stateComp?.long_name ?? stateComp?.short_name ?? ""
  const stateShortName = stateComp?.short_name ?? ""

  return { addressLine1, city, zip, countryCode, stateName, stateShortName }
}
